import WebTippsPagePreview from './WebTippsPagePreview'
export default WebTippsPagePreview
